import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import NavHeader from "../components/NavHeader";
import WebEmbedder from "../components/web/WebEmbedder";
import WebThemeForm from "../forms/web/WebThemeForm";
import WebSideBar from "../components/web/WebSideBar";
import WebPreviews from "../components/web/WebPreviews";

import WebTourIcon from "../assets/svgs/preview-link.svg";
import PreviewIcon from "../assets/svgs/view.svg";
import styles from "./WebThemeDesignerPage.module.scss";
import { useState } from "react";
import styled from "styled-components";
import clsx from "clsx";

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;

  img {
    margin-right: 10px;
    height: 20px;
    width: 20px;
  }
`;

export default function WebThemeDesignerPage() {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <WebThemeForm>
      <NavHeader />
      <Row>
        <Col xs={12} sm={12} md={5} lg={4} xl={2}>
          <WebSideBar />
        </Col>
        <Col xs={12} sm={12} md={7} lg={8} xl={10}>
          <Nav tabs>
            <NavItem>
              <StyledNavLink
                className={clsx({
                  active: activeTab === "1",
                })}
                onClick={() => setActiveTab("1")}
              >
                <img src={PreviewIcon} alt="Preview" />
                Previews
              </StyledNavLink>
            </NavItem>
            <NavItem>
              <StyledNavLink
                className={clsx({
                  active: activeTab === "2",
                })}
                onClick={() => setActiveTab("2")}
              >
                <img src={WebTourIcon} alt="Web Tour" />
                Web Tour
              </StyledNavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <WebPreviews className={styles.web} />
            </TabPane>
            <TabPane tabId="2">
              <WebEmbedder />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </WebThemeForm>
  );
}
